
// PawsHealth: Utilisation du service Firebase partagé
import { getFirebaseAuth, getFirebaseDB } from '../../shared/services/firebase';

export const auth = getFirebaseAuth();
export const db = getFirebaseDB();

// Exporter les fonctions pour l'utiliser dans App.tsx
export { getFirebaseDB };
